import { AccessTokenResponse } from 'react-aad-msal';
import { call, select } from 'redux-saga/effects';
import { AuthenticationContextValue } from '../../authentication';
import { AccessTokenScopes } from '../../authentication/context';
import { getAuthenticationContext } from '../selectors/authentication.selectors';

export function* getAccessToken(...scopes: (keyof AccessTokenScopes)[]) {
    const authenticationContext: AuthenticationContextValue = yield select(getAuthenticationContext);
    const tokenResponse: AccessTokenResponse = yield call(authenticationContext.getAccessToken, {
        scopes: scopes.map((scope) => {
            return authenticationContext.scopes[scope];
        }),
    });

    return tokenResponse.accessToken;
}
